module.exports = __webpack_public_path__ + "static/media/parceiros_mobile.19c4f60d.png";